export default __webpack_public_path__ + "static/pedals-illustration@2x-66f4cf8c30339c73a9be05f8bc4c449e.png";